import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Star } from 'lucide-react';
import './navbar.css';

const LINKS = [
  { href: '/',              label: 'Início' },
  { href: '/sobre',         label: 'Sobre' },
  { href: '/transparencia', label: 'Transparência' },
  { href: '/galeria',       label: 'Galeria' },
  { href: '/eventos',       label: 'Eventos' },
  { href: '/festejo',       label: 'Festejo Junino' },
];

export default function Navbar() {
  const [menuAberto, setMenuAberto] = useState(false);
  const [rolado, setRolado] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fn = () => setRolado(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setMenuAberto(false); }, [location]);

  return (
    <nav className={`navbar ${rolado ? 'navbar-rolado' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <div className="logo-diamante">
            <Star size={20} fill="currentColor" className="logo-estrela" />
          </div>
          <div className="logo-texto">
            <span className="logo-nome">licmab</span>
            <span className="logo-subtitulo">Liga Cultural de Marabá</span>
          </div>
        </Link>

        <ul className={`navbar-links ${menuAberto ? 'aberto' : ''}`}>
          {LINKS.map(link => (
            <li key={link.href}>
              <Link
                to={link.href}
                className={`navbar-link ${location.pathname === link.href ? 'ativo' : ''}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <button
          className="navbar-menu-btn"
          onClick={() => setMenuAberto(!menuAberto)}
          aria-label="Menu"
        >
          {menuAberto ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </nav>
  );
}